"use client"
import { useEffect, useState } from 'react';
import { useModal } from "./modal/Provdier"
import { IBus } from "@/types"
import { useCookies } from 'react-cookie';

export default function StartBtn({ bus, isExpired, className, children }: { bus: IBus, isExpired: boolean, className: string, children: React.ReactNode }) {
  const { openModal } = useModal()
  const [userInfoCookie] = useCookies(['userInfo']);
  const [btnLinkState, setBtnLinkState] = useState<string>('');
  useEffect(() => {
    const role = userInfoCookie?.userInfo?.role;
    let btnLink = bus.btnLink;
    if (role) {
      btnLink = `/chat/school/homework/${role == 1 ? 's' : 't'}/`;
    }
    setBtnLinkState(btnLink);
  }, [userInfoCookie?.userInfo?.role]);
  return (
    <>
      {
        isExpired ? (
          <div className={className} onClick={openModal}>
            {children}
          </div>
        ) : (
          <a className={className} href={btnLinkState} target="_blank">
            {children}
          </a>
        )
      }
    </>
  )
}

